import config from "../config"
import axios from "axios"

const BASE_URL = config.BASE_URL
const apiX = axios.create({
  baseURL: BASE_URL,
})
/**
 * Note : return a list of group actions of the specified mpid
 * @param _mpId
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getGroups = (_mpId) => {
  return apiX.get(BASE_URL + `api/group/list/` + _mpId)
}

export const changeGroupName = (_gId, _name) => {
  const param = {
    gid: _gId,
    name: _name,
  }

  return apiX.post(BASE_URL + `api/group/change`, param)
}

/**
 * Note : Add a new group action
 * @param _mpId
 * @param _groupName
 * @returns {Promise<AxiosResponse<any>>}
 */
export const addGroup = (_mpId, _groupName) => {
  const param = {
    mpid: _mpId,
    groupName: _groupName,
  }

  return apiX.post(BASE_URL + `api/group/add`, param)
}
